import React from 'react';
import { CheckCircle2, Star, ShieldCheck, Download, Zap } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-4 pb-10 md:pt-10 md:pb-16 px-4 overflow-hidden" data-id="element-119">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#C6F432] opacity-5 rounded-full blur-[100px] pointer-events-none" data-id="element-120"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-121">
        {/* MOBILE LAYOUT: tight, mockup-first ordering */}
        <div className="flex flex-col items-center text-center lg:hidden" data-id="element-122">
          <p className="text-[#C6F432] font-bold tracking-widest uppercase text-[11px] mb-2 flex items-center justify-center gap-2" data-id="element-123">
            <Zap size={14} className="fill-[#C6F432]" data-id="element-124" />
            Sistema N°1 para Profes de Pádel
            <Zap size={14} className="fill-[#C6F432]" data-id="element-125" />
          </p>

          {/* Headline */}
          <h1 className="text-5xl sm:text-6xl font-anton text-white leading-[0.95] mb-2" data-id="element-126">
            MEGAPACK <span className="text-[#C6F432]" data-id="element-127">PADEL</span>
            <br data-id="element-128" />
            RESUELTO™
          </h1>

          {/* Subheadline */}
          <p className="text-base sm:text-lg text-gray-300 font-medium mb-3" data-id="element-129">
            Tu sistema completo de clases de pádel
          </p>

          {/* Mockup — same size, moved up, floating */}
          <a href="#precio-lanzamiento" className="block cursor-pointer mb-3 animate-float" data-id="element-130">
            <img src="https://cdn.magicpatterns.com/uploads/uZQbJXmGDnpMeRyqSRAHhf/ChatGPT_Image_6_may_2026,_11_57_15-Photoroom.png" alt="Megapack Padel Resuelto" className="w-full max-w-lg mx-auto drop-shadow-[0_20px_50px_rgba(198,244,50,0.2)]" data-id="element-131" />
          </a>

          {/* Descriptive text below mockup */}
          <p className="text-base text-gray-300 font-medium mb-1" data-id="element-132">
            Tu año completo de clases de pádel listo
          </p>
          <p className="text-sm text-gray-400 max-w-md mb-3" data-id="element-133">
            Planificación anual, sesiones estructuradas, progresiones técnicas y
            clases por nivel.
          </p>
          <div className="inline-block bg-[#C6F432]/10 border border-[#C6F432]/30 text-[#C6F432] font-bold px-4 py-1.5 rounded-full mb-4 text-sm" data-id="element-134">
            👉 Sin improvisar nunca más
          </div>

          {/* CTA */}
          <Button className="w-full max-w-md text-base py-4 mb-4 animate-pulse" data-id="element-135">
            💥 QUIERO MI MEGAPACK PADEL RESUELTO
          </Button>

          {/* Compact badges */}
          <div className="grid grid-cols-2 gap-2 w-full max-w-md mb-4" data-id="element-136">
            <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-2 rounded-lg border border-white/5" data-id="element-137">
              <Download className="text-[#C6F432]" size={16} data-id="element-138" />
              <span className="font-medium text-xs" data-id="element-139">PDF digital</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-2 rounded-lg border border-white/5" data-id="element-140">
              <Zap className="text-[#C6F432]" size={16} data-id="element-141" />
              <span className="font-medium text-xs" data-id="element-142">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-2 rounded-lg border border-white/5" data-id="element-143">
              <CheckCircle2 className="text-[#C6F432]" size={16} data-id="element-144" />
              <span className="font-medium text-xs" data-id="element-145">Todos los niveles</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-2 rounded-lg border border-white/5" data-id="element-146">
              <ShieldCheck className="text-[#C6F432]" size={16} data-id="element-147" />
              <span className="font-medium text-xs" data-id="element-148">Garantía 7 días</span>
            </div>
          </div>

          <p className="text-xs text-gray-500 mb-2" data-id="element-149">
            Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia
          </p>
          <div className="flex items-center justify-center gap-2 flex-wrap text-xs text-gray-400" data-id="element-150">
            <div className="bg-white/5 px-2.5 py-1 rounded-full" data-id="element-151">
              <span className="font-bold text-white" data-id="element-152">+300</span> profes
            </div>
            <div className="flex items-center gap-1 bg-white/5 px-2.5 py-1 rounded-full" data-id="element-153">
              <Star className="fill-yellow-400 text-yellow-400" size={12} data-id="element-154" />
              <span className="font-bold text-white" data-id="element-155">4.9/5</span>
            </div>
            <div className="bg-white/5 px-2.5 py-1 rounded-full" data-id="element-156">
              🇦🇷 Todo el país
            </div>
          </div>
        </div>

        {/* DESKTOP LAYOUT: original 2-column */}
        <div className="hidden lg:block" data-id="element-157">
          <div className="text-center mb-8" data-id="element-158">
            <p className="text-[#C6F432] font-bold tracking-widest uppercase mb-4 flex items-center justify-center gap-2" data-id="element-159">
              <Zap size={20} className="fill-[#C6F432]" data-id="element-160" />
              Sistema N°1 para Profesores de Pádel en Argentina
              <Zap size={20} className="fill-[#C6F432]" data-id="element-161" />
            </p>
            <h1 className="text-7xl xl:text-8xl font-anton text-white mb-6 leading-tight drop-shadow-lg" data-id="element-162">
              MEGAPACK <span className="text-[#C6F432]" data-id="element-163">PADEL</span>
              <br data-id="element-164" />
              RESUELTO™
            </h1>
            <p className="text-2xl text-gray-300 font-medium max-w-3xl mx-auto mb-2" data-id="element-165">
              Tu año completo de clases de pádel listo
            </p>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-166">
              Planificación anual, sesiones estructuradas, progresiones técnicas
              y clases por nivel.
            </p>
            <div className="inline-block bg-[#C6F432]/10 border border-[#C6F432]/30 text-[#C6F432] font-bold px-6 py-2 rounded-full mt-6 text-lg" data-id="element-167">
              👉 Sin improvisar nunca más
            </div>
          </div>

          <div className="flex flex-row items-center justify-center gap-12 mt-12" data-id="element-168">
            <div className="w-1/2 relative" data-id="element-169">
              <a href="#precio-lanzamiento" className="block cursor-pointer animate-float" data-id="element-170">
                <img src="https://cdn.magicpatterns.com/uploads/uZQbJXmGDnpMeRyqSRAHhf/ChatGPT_Image_6_may_2026,_11_57_15-Photoroom.png" alt="Megapack Padel Resuelto" className="w-full max-w-lg mx-auto drop-shadow-[0_20px_50px_rgba(198,244,50,0.2)]" data-id="element-171" />
              </a>
            </div>

            <div className="w-1/2 flex flex-col items-start text-left" data-id="element-172">
              <div className="grid grid-cols-2 gap-4 mb-8 w-full max-w-md" data-id="element-173">
                <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-3 rounded-lg border border-white/5" data-id="element-174">
                  <Download className="text-[#C6F432]" size={20} data-id="element-175" />
                  <span className="font-medium text-sm" data-id="element-176">PDF digital</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-3 rounded-lg border border-white/5" data-id="element-177">
                  <Zap className="text-[#C6F432]" size={20} data-id="element-178" />
                  <span className="font-medium text-sm" data-id="element-179">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-3 rounded-lg border border-white/5" data-id="element-180">
                  <CheckCircle2 className="text-[#C6F432]" size={20} data-id="element-181" />
                  <span className="font-medium text-sm" data-id="element-182">Todos los niveles</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 bg-[#0F1F3D] p-3 rounded-lg border border-white/5" data-id="element-183">
                  <ShieldCheck className="text-[#C6F432]" size={20} data-id="element-184" />
                  <span className="font-medium text-sm" data-id="element-185">Garantía 7 días</span>
                </div>
              </div>

              <Button className="w-full max-w-md text-xl py-5 mb-6 animate-pulse" data-id="element-186">
                💥 QUIERO MI MEGAPACK PADEL RESUELTO
              </Button>

              <div className="flex flex-col items-start gap-2 text-sm text-gray-400" data-id="element-187">
                <p data-id="element-188">Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia</p>
                <div className="flex items-center gap-4 mt-2 flex-wrap" data-id="element-189">
                  <div className="flex items-center gap-1 bg-white/5 px-3 py-1 rounded-full" data-id="element-190">
                    <span className="font-bold text-white" data-id="element-191">+300</span> profes ya
                    lo usan
                  </div>
                  <div className="flex items-center gap-1 bg-white/5 px-3 py-1 rounded-full" data-id="element-192">
                    <Star className="fill-yellow-400 text-yellow-400" size={14} data-id="element-193" />
                    <span className="font-bold text-white" data-id="element-194">4.9/5</span>{' '}
                    valoración
                  </div>
                  <div className="flex items-center gap-1 bg-white/5 px-3 py-1 rounded-full" data-id="element-195">
                    🇦🇷 Acceso en todo el país
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}